import { useState } from 'react';
import { useProjectOptions } from '../../hooks/useProjects';
import { useSearchInventoryArticles } from '../../hooks/useInventoryArticles';

/** Opciones compartidas por los filtros operativos de vivienda y artículo. */
export const useMaterialScopeOptions = () => {
  const [search, setSearch] = useState('');
  const projects = useProjectOptions();
  const articles = useSearchInventoryArticles(search, { enabled: search.trim().length >= 3 });
  const raw = articles.data;
  return {
    projects: projects.data || [],
    articles: Array.isArray(raw) ? raw : raw?.results || raw?.items || [],
    search,
    setSearch,
    loading: articles.isFetching,
  };
};
